import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "../../../components";

const RadioWithTooltip = props => {
	const { id, name, handleChange, checked, label, tooltipMessage, children } = props;
	return (
		<div className="col-xs-12 radio">
			<label htmlFor={id}>
				<input
					type="radio"
					name={name}
					id={id}
					onChange={handleChange}
					checked={checked}
				/>
				<div>
					{children}
					{label}
					<Tooltip content={tooltipMessage}>
						<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
					</Tooltip>
				</div>
			</label>
		</div>
	);
};

RadioWithTooltip.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
	label: PropTypes.string.isRequired,
	tooltipMessage: PropTypes.string.isRequired,
	children: PropTypes.any,
};

RadioWithTooltip.defaultProps = {
	children: "",
};

export default RadioWithTooltip;
